import React from "react";
import moment from "moment";
import logo from "../../../assets/images/asset-planet-background.png";
import assetHomeIcon from "../../../assets/images/asset.png";

export const AssetsPDFReport = ({
  assetsList,
  inventoryList,
  collectiblesList,
  totalAssets,
  clientName,
  chartImage,
}) => {
  return (
    <div
      id="assets-report-pdf"
      style={{
        padding: "60px 30px",
        backgroundColor: "#fff",
        width: "900px",
        margin: "0 auto",
        fontFamily: "'Inter', sans-serif",
        color: "#000",
        boxSizing: "border-box",
      }}
    >
      {/* Logo and Header */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "30px",
          borderBottom: "1px solid #eee",
          paddingBottom: "20px",
        }}
      >
        <div style={{ display: "flex", alignItems: "center" }}>
          <img
            src={logo}
            alt="Logo"
            style={{
              height: "50px",
              objectFit: "contain",
            }}
          />
        </div>
        <div style={{ textAlign: "right" }}>
          <div
            style={{
              fontSize: "12px",
              color: "#666",
              fontWeight: "600",
            }}
          >
            Report Generated
          </div>
          <div
            style={{
              fontSize: "15px",
              fontWeight: "bold",
              color: "#1F3C88",
              marginTop: "4px",
            }}
          >
            {moment().format("MMMM D, YYYY")}
          </div>
        </div>
      </div>

      {/* Title & Client Name */}
      {/* Title & Client Name */}
      <div style={{ marginBottom: "25px" }}>
        <h1
          style={{
            fontSize: "32px",
            fontWeight: "800",
            margin: "0 0 10px 0",
            color: "#1c1c1c",
            letterSpacing: "-0.5px",
          }}
        >
          Assets Report
        </h1>
        <div style={{ fontSize: "16px" }}>
          <span style={{ color: "#666", fontWeight: "600" }}>Client: </span>
          <span style={{ color: "#1F3C88", fontWeight: "bold" }}>
            {clientName || "Roger Thames"}
          </span>
        </div>
      </div>

      {/* Total Assets Summary Tile */}
      <div data-pdf-section style={{ display: "flex", gap: "20px", marginBottom: "40px" }}>
        <div style={{
          display: "flex",
          alignItems: "center",
          backgroundColor: "#f9f9f9",
          padding: "20px",
          borderRadius: "12px",
          border: "1px solid #f0f0f0",
          minWidth: "300px"
        }}>
          <img src={assetHomeIcon} alt="Asset Icon" style={{ width: "40px", height: "40px", marginRight: "16px", objectFit: "contain" }} />
          <div>
            <div style={{ fontSize: "13px", color: "#666", fontWeight: "600", textTransform: "uppercase", marginBottom: "4px" }}>
              Total Assets
            </div>
            <div style={{ fontSize: "22px", fontWeight: "900", color: "#1F3C88" }}>
              ${totalAssets || "0.00"}
            </div>
          </div>
        </div>
      </div>

      <h2
        style={{
          fontSize: "22px",
          fontWeight: "bold",
          marginBottom: "25px",
          color: "#1c1c1c",
          borderLeft: "5px solid #1F3C88",
          paddingLeft: "15px",
        }}
      >
        All Assets
      </h2>

      <div
        data-pdf-section
        style={{
          marginBottom: "60px",
          textAlign: "center",
          minHeight: "350px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "#fff",
          padding: "20px",
          borderRadius: "12px",
          border: "1px solid #f0f0f0",
        }}
      >
        {chartImage ? (
          <img
            src={chartImage}
            alt="Asset Chart"
            style={{
              maxWidth: "100%",
              height: "auto",
              display: "block",
              margin: "0 auto",
            }}
          />
        ) : (
          <div style={{ color: "#ccc", fontSize: "18px", fontStyle: "italic" }}>
            Chart data is being processed...
          </div>
        )}
      </div>
      <h2
        style={{
          fontSize: "22px",
          fontWeight: "bold",
          marginBottom: "25px",
          color: "#1c1c1c",
          borderLeft: "5px solid #1F3C88",
          paddingLeft: "15px",
        }}
      >
        Assets
      </h2>
      <table
        data-pdf-section
        style={{
          width: "100%",
          borderCollapse: "separate",
          borderSpacing: "0",
          marginBottom: "60px",
          borderRadius: "12px",
          overflow: "hidden",
          border: "1px solid #E0E0E0",
          boxShadow: "0 4px 6px rgba(0,0,0,0.02)",
        }}
      >
        <thead>
          <tr style={{ backgroundColor: "#1F3C88", color: "#fff" }}>
            <th
              style={{
                padding: "14px",
                textAlign: "left",
                fontSize: "13px",
                fontWeight: "600",
              }}
            >
              Name of Asset
            </th>
            <th
              style={{
                padding: "14px",
                textAlign: "left",
                fontSize: "13px",
                fontWeight: "600",
              }}
            >
              Monetary Value
            </th>
            <th
              style={{
                padding: "14px",
                textAlign: "left",
                fontSize: "13px",
                fontWeight: "600",
              }}
            >
              Account Type
            </th>
            <th
              style={{
                padding: "14px",
                textAlign: "left",
                fontSize: "13px",
                fontWeight: "600",
              }}
            >
              Held Where
            </th>
            <th
              style={{
                padding: "14px",
                textAlign: "left",
                fontSize: "13px",
                fontWeight: "600",
              }}
            >
              Value as of Date
            </th>
          </tr>
        </thead>
        <tbody>
          {assetsList && assetsList.length > 0 ? (
            assetsList.map((asset, index) => (
              <tr
                key={index}
                style={{
                  backgroundColor: index % 2 === 0 ? "#fff" : "#fcfcfc",
                }}
              >
                <td
                  style={{
                    padding: "14px",
                    borderTop: "1px solid #E0E0E0",
                    fontSize: "13px",
                    color: "#333",
                  }}
                >
                  {asset["Name of Asset"] || "N/A"}
                </td>
                <td
                  style={{
                    padding: "14px",
                    borderTop: "1px solid #E0E0E0",
                    fontSize: "13px",
                    fontWeight: "600",
                    color: "#1F3C88",
                  }}
                >
                  $
                  {asset["Monetary Value"]
                    ? asset["Monetary Value"].toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })
                    : "0.00"}
                </td>
                <td
                  style={{
                    padding: "14px",
                    borderTop: "1px solid #E0E0E0",
                    fontSize: "13px",
                    color: "#555",
                  }}
                >
                  {asset["Account Type/Titled"] || "N/A"}
                </td>
                <td
                  style={{
                    padding: "14px",
                    borderTop: "1px solid #E0E0E0",
                    fontSize: "13px",
                    color: "#555",
                  }}
                >
                  {asset["Held Where"] || "N/A"}
                </td>
                <td
                  style={{
                    padding: "14px",
                    borderTop: "1px solid #E0E0E0",
                    fontSize: "13px",
                    color: "#555",
                  }}
                >
                  {asset["Value as of Date"]
                    ? moment(asset["Value as of Date"]).format("MMM, YYYY")
                    : "N/A"}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td
                colSpan="5"
                style={{
                  padding: "30px",
                  textAlign: "center",
                  color: "#999",
                  fontSize: "16px",
                }}
              >
                No data to show
              </td>
            </tr>
          )}
        </tbody>
      </table>

      <h2
        style={{
          fontSize: "22px",
          fontWeight: "bold",
          marginBottom: "25px",
          color: "#1c1c1c",
          borderLeft: "5px solid #1F3C88",
          paddingLeft: "15px",
        }}
      >
        Inventory
      </h2>
      <table
        data-pdf-section
        style={{
          width: "100%",
          borderCollapse: "separate",
          borderSpacing: "0",
          marginBottom: "60px",
          borderRadius: "12px",
          overflow: "hidden",
          border: "1px solid #E0E0E0",
          boxShadow: "0 4px 6px rgba(0,0,0,0.02)",
        }}
      >
        <thead>
          <tr style={{ backgroundColor: "#1F3C88", color: "#fff" }}>
            <th
              style={{
                padding: "14px",
                textAlign: "left",
                fontSize: "13px",
                fontWeight: "600",
              }}
            >
              Property Name
            </th>
            <th
              style={{
                padding: "14px",
                textAlign: "left",
                fontSize: "13px",
                fontWeight: "600",
              }}
            >
              Monetary Value
            </th>
            <th
              style={{
                padding: "14px",
                textAlign: "left",
                fontSize: "13px",
                fontWeight: "600",
              }}
            >
              Account Type
            </th>
            <th
              style={{
                padding: "14px",
                textAlign: "left",
                fontSize: "13px",
                fontWeight: "600",
              }}
            >
              Held Where
            </th>
            <th
              style={{
                padding: "14px",
                textAlign: "left",
                fontSize: "13px",
                fontWeight: "600",
              }}
            >
              Value as of Date
            </th>
          </tr>
        </thead>
        <tbody>
          {inventoryList && inventoryList.length > 0 ? (
            inventoryList.map((item, index) => (
              <tr
                key={index}
                style={{
                  backgroundColor: index % 2 === 0 ? "#fff" : "#fcfcfc",
                }}
              >
                <td
                  style={{
                    padding: "14px",
                    borderTop: "1px solid #E0E0E0",
                    fontSize: "13px",
                    color: "#333",
                  }}
                >
                  {item["Name of Asset"] || "N/A"}
                </td>
                <td
                  style={{
                    padding: "14px",
                    borderTop: "1px solid #E0E0E0",
                    fontSize: "13px",
                    fontWeight: "600",
                    color: "#1F3C88",
                  }}
                >
                  $
                  {item["Monetary Value"]
                    ? item["Monetary Value"].toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })
                    : "0.00"}
                </td>
                <td
                  style={{
                    padding: "14px",
                    borderTop: "1px solid #E0E0E0",
                    fontSize: "13px",
                    color: "#555",
                  }}
                >
                  {item["Account Type/Titled"] || "N/A"}
                </td>
                <td
                  style={{
                    padding: "14px",
                    borderTop: "1px solid #E0E0E0",
                    fontSize: "13px",
                    color: "#555",
                  }}
                >
                  {item["Held Where"] || "N/A"}
                </td>
                <td
                  style={{
                    padding: "14px",
                    borderTop: "1px solid #E0E0E0",
                    fontSize: "13px",
                    color: "#555",
                  }}
                >
                  {item["Value as of Date"]
                    ? moment(item["Value as of Date"]).format("MMM, YYYY")
                    : "N/A"}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td
                colSpan="5"
                style={{
                  padding: "30px",
                  textAlign: "center",
                  color: "#999",
                  fontSize: "16px",
                }}
              >
                No data to show
              </td>
            </tr>
          )}
        </tbody>
      </table>

      <h2
        style={{
          fontSize: "22px",
          fontWeight: "bold",
          marginBottom: "25px",
          color: "#1c1c1c",
          borderLeft: "5px solid #1F3C88",
          paddingLeft: "15px",
        }}
      >
        Collectibles
      </h2>
      <table
        data-pdf-section
        style={{
          width: "100%",
          borderCollapse: "separate",
          borderSpacing: "0",
          marginBottom: "60px",
          borderRadius: "12px",
          overflow: "hidden",
          border: "1px solid #E0E0E0",
          boxShadow: "0 4px 6px rgba(0,0,0,0.02)",
        }}
      >
        <thead>
          <tr style={{ backgroundColor: "#1F3C88", color: "#fff" }}>
            <th
              style={{
                padding: "14px",
                textAlign: "left",
                fontSize: "13px",
                fontWeight: "600",
              }}
            >
              Description
            </th>
            <th
              style={{
                padding: "14px",
                textAlign: "left",
                fontSize: "13px",
                fontWeight: "600",
              }}
            >
              Monetary Value
            </th>
            <th
              style={{
                padding: "14px",
                textAlign: "left",
                fontSize: "13px",
                fontWeight: "600",
              }}
            >
              Account Type
            </th>
            <th
              style={{
                padding: "14px",
                textAlign: "left",
                fontSize: "13px",
                fontWeight: "600",
              }}
            >
              Held Where
            </th>
            <th
              style={{
                padding: "14px",
                textAlign: "left",
                fontSize: "13px",
                fontWeight: "600",
              }}
            >
              Value as of Date
            </th>
          </tr>
        </thead>
        <tbody>
          {collectiblesList && collectiblesList.length > 0 ? (
            collectiblesList.map((item, index) => (
              <tr
                key={index}
                style={{
                  backgroundColor: index % 2 === 0 ? "#fff" : "#fcfcfc",
                }}
              >
                <td
                  style={{
                    padding: "14px",
                    borderTop: "1px solid #E0E0E0",
                    fontSize: "13px",
                    color: "#333",
                  }}
                >
                  {item["Name of Asset"] || "N/A"}
                </td>
                <td
                  style={{
                    padding: "14px",
                    borderTop: "1px solid #E0E0E0",
                    fontSize: "13px",
                    fontWeight: "600",
                    color: "#1F3C88",
                  }}
                >
                  $
                  {item["Monetary Value"]
                    ? item["Monetary Value"].toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })
                    : "0.00"}
                </td>
                <td
                  style={{
                    padding: "14px",
                    borderTop: "1px solid #E0E0E0",
                    fontSize: "13px",
                    color: "#555",
                  }}
                >
                  {item["Account Type/Titled"] || "N/A"}
                </td>
                <td
                  style={{
                    padding: "14px",
                    borderTop: "1px solid #E0E0E0",
                    fontSize: "13px",
                    color: "#555",
                  }}
                >
                  {item["Held Where"] || "N/A"}
                </td>
                <td
                  style={{
                    padding: "14px",
                    borderTop: "1px solid #E0E0E0",
                    fontSize: "13px",
                    color: "#555",
                  }}
                >
                  {item["Value as of Date"]
                    ? moment(item["Value as of Date"]).format("MMM, YYYY")
                    : "N/A"}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td
                colSpan="5"
                style={{
                  padding: "30px",
                  textAlign: "center",
                  color: "#999",
                  fontSize: "16px",
                }}
              >
                No data to show
              </td>
            </tr>
          )}
        </tbody>
      </table>

      <div
        data-pdf-section
        style={{
          fontSize: "13px",
          lineHeight: "1.6",
          color: "#000000",
          marginTop: "60px",
          textAlign: "center",
          padding: "20px 60px",
          borderTop: "1px solid #eee",
        }}
      >
        <strong>Confidential & Unaudited:</strong> This report is intended solely for the named recipient and is for informational purposes only. The data reflects information provided by the user and has not been audited by <strong>Asset Planet.</strong> <strong>Asset Planet</strong> makes no warranty regarding the data's accuracy or completeness and does not provide financial, legal, or tax advice through this report. Users are encouraged to consult with a qualified professional for their specific circumstances.
      </div>
    </div>
  );
};
